<div class="dialog-container">
  <div class="title">
    <mat-icon>upload</mat-icon>
    <span>{{ data.title }}</span>
  </div>
  <div class="content">
    <cotecna-nf-form
      #naturalForm
      [config]="naturalFormConfig"
      [sections]="sections"
      [controls]="controls"
      >
    </cotecna-nf-form>
    <div>
      <cotecna-file-upload
        id="fileUploadComponent"
        [options]="fileUploadOptions"
        (filesSelected)="onFilesSelected($event)"
        >
      </cotecna-file-upload>
      @if (isDownloadTemplateVisible) {
        <a
          id="downoad-item-template"
          mat-button
          href="./assets/files/Items.xlsx"
          target="_blank"
          >DOWNLOAD TEMPLATE</a
          >
        }
      </div>
    </div>
    <div class="actions">
      @if (!isDownloadTemplateVisible) {
        <button
          id="download-template"
          [disabled]="disableDownload"
          (click)="download()"
          mat-button
          >
          DOWNLOAD TEMPLATE
        </button>
      }
      <button id="cancel-import-items" (click)="cancel()" mat-button>
        CANCEL
      </button>
      <button
        id="import-items"
        [disabled]="!(file && canImport)"
        (click)="import()"
        mat-button
        color="primary"
        >
        IMPORT
      </button>
    </div>
  </div>
